import React, { Fragment } from "react";
import FormInputRichText from "root/ReactHookForm/FormComponents/FormInputRichText";
import { EMAIL_ALL_FIELDS } from "root/Modals/ModalEmailAll";
import BootstrapRow from "root/ReactHookForm/ui/BootstrapRow";
import BootstrapCol from "root/ReactHookForm/ui/BootstrapCol";



const FormFragmentEmailBody= ({data, watch, control, register, formErrors, sectionName, readOnly}) =>
{

    return (
        <Fragment>
            <BootstrapRow>
                <BootstrapCol width={12}>
                    <label className='form-label'>Message</label>
                    <FormInputRichText readOnly={readOnly}
                                       name={EMAIL_ALL_FIELDS.MESSAGE}
                                       control={control} register={register} sectionName={sectionName} required={false} rows={10} maxLength={4000}
                                       formErrors={formErrors}/>
                </BootstrapCol>
            </BootstrapRow>
        </Fragment>
    );
}

export default FormFragmentEmailBody;